import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";
import trans from "../../utils";

export default function AntTextArea({
	title,
	id,
	type,
	placeholder,
	disabled,
	min,
	max,
	item,
	preview,
	activeInput,
	readOnly,
	addData,
	setSubmitData,
	submitData,
}) {
	const [value, setValue] = useState("");
	const currentValue = addData
		? submitData?.find((i) => i.key === item.key)?.value ?? ""
		: item?.value ?? value ?? "";
	const validate = addData
		? addData?.touched?.fields?.[item?.key]?.value &&
		  item?.required?.value &&
		  currentValue === ""
		: item?.required?.value && value === "";
	const styleValidate = addData
		? addData?.touched?.fields?.[item?.key]?.value &&
		  item?.required?.value &&
		  currentValue === ""
		: preview !== true && value === "" && item?.required?.value;

	console.log("TextValues", value);
	console.log("Adddata", addData);
	console.log("CurrentValue", currentValue);
	return (
		<div style={item?.css}>
			<label
				htmlFor={item?.key}
				className="form-label d-flex align-items-center"
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
			>
				<div>{item?.title}</div>
				{item?.required?.value && value === "" && (
					<div className="text-danger ms-2">*</div>
				)}
			</label>
			<TextArea
				type={item?.title}
				placeholder={item?.placeholder}
				id={item?.key}
				onChange={(e) => {
					const newValue = e.target.value;
					setValue(newValue);

					if (addData) {
						setSubmitData((prev) => {
							// Remove existing item with same key if you want to replace it
							const filtered = prev?.filter((i) => i.key !== item.key) || [];
							return [
								...filtered,
								{
									key: item.key,
									name: item.name,
									title: item.title,
									value: newValue,
								},
							];
						});

						addData.setFieldTouched(`fields[${item.key}].value`, true);
					}
				}}
				onBlur={() => {
					if (addData) {
						addData.setFieldTouched(`fields[${item?.key}].value`, true);
					}
				}}
				value={currentValue}
				style={{
					borderColor: styleValidate ? "red" : "",
				}}
				rows={4}
				readOnly={readOnly}
			/>
			{preview !== true ? (
				<>
					{validate && (
						<div className="text-danger mt-1">
							{trans(item?.required?.validationMessage)}
						</div>
					)}
				</>
			) : (
				""
			)}
		</div>
	);
}
